export default {
  responsive: {
    tablet: 1024,
    mobil: 768,
  },
};
